import { useState, useEffect, useContext } from "react";
import { IoArrowDownOutline, IoArrowUpOutline } from "react-icons/io5";
import { MdOutlineCurrencyExchange } from "react-icons/md";
import PersianNumber from "../../utils/PersianNumber/PersianNumber";
import { Link, NavLink, Navigate } from "react-router-dom";
import { pricePublicContext } from "../../context/PublicContext/PricePublicContext/PricePublicContext";

const ListUi = ({ roleName, _item, userInfo }) => {
  // استفاده از context
  const {
    statePrice,
    setStatePrice,
    stateWeight,
    setStateWeight,
    stateTotal,
    setStateTotal,
    description,
    setDescription,
    transactionId,
    setTransactionId,
    product_name,
    setProduct_name,
    customeruser,
    setCustomeruser,
    bos,
    setBos,
    is_orderi,
    setIs_orderi,
    handlePostTransaction,
    handlePriceChange,
    handleWeightChange,
    handleTotalChange,
    addCommas,
    resultModal,
    setResultModal,
    orderModal,
    setOrderModal,
    data,
    setData,
    type,
    setType,
    handleChangeBuyClosePriceProduct,
    handleChangeSellClosePriceProduct,
    handleChangeSellAutoPilotProduct,
    handleChangeBuyAutoPilotProduct,
  } = useContext(pricePublicContext);

  // State for transaction modal
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [transactionType, setTransactionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // استایل برای بزرگ کردن فونت‌ها
  const largerStyles = {
    tableCell: "text-lg", // بزرگ کردن متن‌های جدول
    productName: "text-xl font-bold", // نام محصول درشت‌تر
    priceText: "text-xl font-semibold", // قیمت‌ها درشت‌تر
    lastUpdate: "text-base", // آخرین بروزرسانی بزرگتر
    buttonText: "text-base font-medium", // دکمه‌ها بزرگتر
    modalText: "text-lg", // متن‌های مودال بزرگتر
    modalTitle: "text-xl font-bold", // عنوان مودال درشت
    inputText: "text-lg", // متن inputها بزرگتر
    labelText: "text-base font-medium", // labelها بزرگتر
  };

  // تابع برای تعیین کلاس پس‌زمینه
  const getBackgroundClass = () => {
    if (_item.tag === "T") {
      return "bg-[#019682ff]/30";
    } else if (_item.name && _item.name.includes("حاضر")) {
      return "bg-[#0077ffff]/30";
    }
    return "";
  };

  // Handle price click (buy/sell)
  const handlePriceClick = (type) => {
    setTransactionType(type);
    setStatePrice(_item[`${type}_price`]);
    setStateWeight("");
    setStateTotal("");
    setDescription("");
    setShowTransactionModal(true);
    setResultModal(false);
    setOrderModal(true);
  };

  // Calculate total
  const calculateTotal = (price, weight) => {
    if (price && weight) {
      setStateTotal(parseInt(price) * parseInt(weight));
    } else {
      setStateTotal("");
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (isSubmitting) return;
    // آماده کردن دیتا
    const payload = {
      product_name: _item.name,
      customeruser: userInfo[0]?.id,
      bos: transactionType === "buy" ? "B" : "S",
      is_orderi:
        transactionType === "buy"
          ? _item.buy_price !== statePrice
          : _item.sell_price !== statePrice,
      price: statePrice,
      volume: stateWeight,
      amount: stateTotal,
      description: description,
    };

    try {
      // ارسال دیتا
      await handlePostTransaction(payload);

      // بعد از ثبت موفق
      setTransactionId(Math.floor(Math.random() * 1000000));
      setShowTransactionModal(false);
      setResultModal(true);
    } catch (error) {
      console.error("Transaction failed:", error);
      setTransactionId(null);
      setResultModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Reset form
  const resetForm = () => {
    setStatePrice("");
    setStateWeight("");
    setStateTotal("");
    setDescription("");
    setShowTransactionModal(false);
    setResultModal(false);
    setTransactionType("");
    setTransactionId(null);
  };

  return (
    <>
      {/* Main Table Row */}
      <tr
        className={`hover:bg-[#171d3f] ${getBackgroundClass()}`}
        style={{ fontSize: "1.05em" }}
      >
        {/* Product Name */}
        <td className="py-5">
          {" "}
          {/* py-4 به py-5 تغییر کرد */}
          <div
            className={`flex items-center justify-center text-white font-bold ${largerStyles.productName}`}
          >
            {_item.name}
          </div>
        </td>

        {/* Buy Price */}
        <td className="py-5">
          {" "}
          {/* py-4 به py-5 تغییر کرد */}
          <div className="flex flex-col items-center space-y-3">
            {" "}
            {/* space-y-2 به space-y-3 */}
            <div className="text-green-600 flex items-center">
              <div
                onClick={() => handlePriceClick("buy")}
                className={`flex items-center cursor-pointer ${largerStyles.priceText}`}
              >
                {_item.buy_price === -1 ? (
                  "-"
                ) : (
                  <>
                    {_item.buy_format === "+" && (
                      <IoArrowUpOutline className="ml-2 text-xl" />
                    )}
                    {_item.buy_format === "-" && (
                      <IoArrowDownOutline className="text-xl" />
                    )}

                    <PersianNumber
                      value={_item.buy_price}
                      thousandSeparator=","
                    />

                    <span
                      className={`text-sm text-gray-500 mr-1 ${largerStyles.tableCell}`}
                    >
                      تومان
                    </span>
                  </>
                )}
              </div>
            </div>
            {roleName === "ADMIN" && (
              <button
                onClick={() =>
                  handleChangeBuyClosePriceProduct(
                    _item.id,
                    !_item.is_buy_closed,
                    _item.periority,
                    _item.is_sell_closed,
                    _item.is_market_close,
                    _item.buy_auto_pilot,
                    _item.sell_auto_pilot,
                  )
                }
                className={`${largerStyles.buttonText} ${
                  _item.is_buy_closed ? "text-red-600" : "text-green-600"
                }`}
              >
                {_item.is_buy_closed ? "قیمت خرید بسته" : "قیمت خرید باز"}
              </button>
            )}
            {roleName === "ADMIN" && (
              <button
                onClick={() =>
                  handleChangeBuyAutoPilotProduct(
                    _item.id,
                    _item.is_buy_closed,
                    _item.periority,
                    _item.is_sell_closed,
                    _item.is_market_close,
                    !_item.buy_auto_pilot,
                    _item.sell_auto_pilot,
                  )
                }
                className={`${largerStyles.buttonText} ${
                  _item.buy_auto_pilot ? "text-yellow-600" : "text-gray-200"
                }`}
              >
                {_item.buy_auto_pilot ? "خرید خودکار" : "خرید دستی"}
              </button>
            )}
          </div>
        </td>

        {/* Sell Price */}
        <td className="py-5">
          {" "}
          {/* py-4 به py-5 تغییر کرد */}
          <div className="flex flex-col justify-center items-center space-y-3">
            {" "}
            {/* space-y-2 به space-y-3 */}
            <div className="text-red-600 flex items-center">
              <div
                onClick={() => handlePriceClick("sell")}
                className={`flex items-center cursor-pointer ${largerStyles.priceText}`}
              >
                {_item.sell_price === -1 ? (
                  "-"
                ) : (
                  <>
                    {_item.sell_format === "+" && (
                      <IoArrowUpOutline className="ml-2 text-xl" />
                    )}
                    {_item.sell_format === "-" && (
                      <IoArrowDownOutline className="text-xl" />
                    )}{" "}
                    {/* بزرگتر */}
                    <PersianNumber
                      value={_item.sell_price}
                      thousandSeparator=","
                    />
                    {roleName !== "ADMIN" && (
                      <span
                        className={`text-sm text-gray-500 mr-1 ${largerStyles.tableCell}`}
                      >
                        {" "}
                        {/* بزرگتر */}
                        تومان
                      </span>
                    )}
                  </>
                )}
              </div>
            </div>
            {roleName === "ADMIN" && (
              <button
                onClick={() =>
                  handleChangeSellClosePriceProduct(
                    _item.id,
                    !_item.is_sell_closed,
                    _item.periority,
                    _item.is_buy_closed,
                    _item.is_market_close,
                    _item.buy_auto_pilot,
                    _item.sell_auto_pilot,
                  )
                }
                className={`${largerStyles.buttonText} ${
                  _item.is_sell_closed ? "text-red-600" : "text-green-600"
                }`}
              >
                {_item.is_sell_closed ? "قیمت فروش بسته" : "قیمت فروش باز"}
              </button>
            )}
            {roleName === "ADMIN" && (
              <button
                onClick={() =>
                  handleChangeSellAutoPilotProduct(
                    _item.id,
                    _item.is_buy_closed,
                    _item.periority,
                    _item.is_sell_closed,
                    _item.is_market_close,
                    _item.buy_auto_pilot,
                    !_item.sell_auto_pilot,
                  )
                }
                className={`${largerStyles.buttonText} ${
                  _item.sell_auto_pilot ? "text-yellow-600" : "text-gray-200"
                }`}
              >
                {_item.sell_auto_pilot ? "فروش خودکار" : "فروش دستی"}
              </button>
            )}
          </div>
        </td>

        {/* Last Update */}
        <td className="py-4">
          <div
            className={`flex justify-center text-gray-600 ${largerStyles.lastUpdate}`}
          >
            {_item.last_update_time_ago}
          </div>
        </td>
      </tr>

      {/* Transaction Modal */}
      {showTransactionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="w-full max-w-lg">
            {" "}
            {/* max-w-md به max-w-lg تغییر کرد */}
            {!resultModal ? (
              // Transaction Form
              <div className="w-full bg-[#101632] relative rounded-lg">
                {/* Title */}
                <div className="flex justify-center items-center w-full p-6 bg-[#101632] rounded-t-lg">
                  <p
                    className={`${largerStyles.modalTitle} font-medium text-white`}
                  >
                    سفارش{" "}
                    <span
                      className={`${
                        transactionType === "buy"
                          ? "text-green-700"
                          : "text-red-700"
                      }`}
                    >
                      {transactionType === "buy" ? "خرید" : "فروش"}
                    </span>{" "}
                    برای " {_item?.name} "
                  </p>
                </div>

                {/* Confirmation Summary */}
                <div
                  className={`grid grid-cols-2 gap-y-5 justify-items-center pb-5 items-center w-full bg-[#101632] text-white ${largerStyles.modalText}`}
                >
                  {/* Price */}
                  <span className="flex flex-col items-center space-y-2">
                    <span className="font-medium">
                      {_item.tag === "S" ? "قیمت" : "مظنه"}{" "}
                    </span>
                    <span className="font-bold">
                      {statePrice ? (
                        <PersianNumber
                          value={statePrice}
                          thousandSeparator=","
                        />
                      ) : (
                        "-"
                      )}
                    </span>
                  </span>

                  {/* Weight */}
                  <span className="flex flex-col items-center space-y-2">
                    <span className="font-medium">
                      {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                    </span>
                    <span className="font-bold">
                      {stateWeight ? (
                        <PersianNumber
                          value={stateWeight}
                          thousandSeparator=","
                        />
                      ) : (
                        "-"
                      )}
                    </span>
                  </span>

                  {/* Total */}
                  <span className="flex flex-col items-center space-y-2">
                    <span className="font-medium">جمع کل</span>
                    <span className="font-bold">
                      {stateTotal ? (
                        <PersianNumber
                          value={stateTotal}
                          thousandSeparator=","
                        />
                      ) : (
                        "-"
                      )}
                    </span>
                  </span>

                  {/* Description */}
                  <span className="flex flex-col items-center w-40 overflow-hidden text-ellipsis whitespace-nowrap space-y-2">
                    <span className="font-medium">توضیحات</span>
                    <span className="font-bold">{description || "-"}</span>
                  </span>
                </div>
                <div className="border-b-2 border-boxColor" />

                {/* Form Inputs */}
                <div className="w-full px-6 py-6 bg-[#101632]">
                  {" "}
                  {/* py-5 به py-6 */}
                  <form onSubmit={handleSubmit}>
                    <div className="flex flex-col w-full">
                      {/* Order Icon */}
                      {(transactionType === "buy" &&
                        _item.buy_price !== statePrice) ||
                      (transactionType === "sell" &&
                        _item.sell_price !== statePrice) ? (
                        <span className="absolute px-2 py-1 rounded-full top-3 left-2 flex items-center text-slate-300">
                          <div className="group flex relative">
                            <MdOutlineCurrencyExchange
                              size={22}
                              className="animate-spin-slow"
                            />
                            <span className="group-hover:opacity-0 transition-opacity px-1 text-base text-slate-300 rounded-md absolute left-1/2 -translate-x-1/2 translate-y-full opacity-0 m-1 mx-auto">
                              اردری
                            </span>
                          </div>
                        </span>
                      ) : null}

                      {/* Input Fields */}
                      <div className="space-y-5">
                        {" "}
                        {/* space-y-4 به space-y-5 */}
                        {/* Price */}
                        <div>
                          <label
                            htmlFor="price"
                            className={`block mb-3 font-medium text-white ${largerStyles.labelText}`}
                          >
                            {_item.tag === "S" ? "قیمت" : "مظنه"}
                          </label>
                          <input
                            type="text"
                            id="price"
                            autoComplete="off"
                            value={
                              statePrice === -1 ? "" : addCommas(statePrice)
                            }
                            onChange={(e) => handlePriceChange(_item, e)}
                            className={`p-3 w-full bg-[#101632] border-2 border-slate-600 rounded-md focus:outline-none text-gray-200 ${largerStyles.inputText}
                              transactionType === "buy"
                                ? "focus:border-green-600 focus:text-green-600"
                                : "focus:border-red-600 focus:text-red-600"
                            }`}
                          />
                        </div>
                        {/* Weight */}
                        <div>
                          <label
                            htmlFor="weight"
                            className={`block mb-3 font-medium text-white ${largerStyles.labelText}`}
                          >
                            {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            name="weight"
                            value={stateWeight}
                            onChange={(e) => handleWeightChange(_item, e)}
                            className={`p-3 w-full bg-[#101632] border-2 border-slate-600 rounded-md focus:outline-none text-gray-200 ${largerStyles.inputText} 
                              transactionType === "buy"
                                ? "focus:border-green-600 focus:text-green-600"
                                : "focus:border-red-600 focus:text-red-600"
                            }`}
                          />
                        </div>
                        {/* Total */}
                        <div>
                          <label
                            htmlFor="total"
                            className={`block mb-3 font-medium text-white ${largerStyles.labelText}`}
                          >
                            جمع کل
                          </label>
                          <input
                            type="text"
                            id="total"
                            autoComplete="off"
                            value={addCommas(stateTotal)}
                            onChange={(e) => handleTotalChange(_item, e)}
                            className={`p-3 w-full bg-[#101632] border-2 border-slate-600 rounded-md focus:outline-none text-gray-200 ${largerStyles.inputText} 
                              transactionType === "buy"
                                ? "focus:border-green-600 focus:text-green-600"
                                : "focus:border-red-600 focus:text-red-600"
                            }`}
                          />
                        </div>
                        {/* Description */}
                        <div>
                          <label
                            htmlFor="description"
                            className={`block mb-3 font-medium text-white ${largerStyles.labelText}`}
                          >
                            توضیحات
                          </label>
                          <input
                            type="text"
                            id="description"
                            autoComplete="off"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className={`p-3 w-full bg-[#101632] border-2 border-slate-600 rounded-md focus:outline-none text-gray-200 ${largerStyles.inputText}
                              transactionType === "buy"
                                ? "focus:border-green-600 focus:text-green-600"
                                : "focus:border-red-600 focus:text-red-600"
                            }`}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      {setProduct_name(_item.name)}
                      {setCustomeruser(userInfo[0]?.id)}
                      {setBos(transactionType === "buy" ? "B" : "S")}
                      {setIs_orderi(
                        transactionType === "buy"
                          ? _item.buy_price !== statePrice
                          : _item.sell_price !== statePrice,
                      )}
                    </div>
                    {/* Buttons */}
                    <div className="flex justify-center items-center w-full mt-6">
                      {" "}
                      {/* mt-5 به mt-6 */}
                      <button
                        type="button"
                        onClick={resetForm}
                        className={`text-gray-200 tracking-wider mx-4 ${largerStyles.buttonText}`}
                        disabled={isSubmitting}
                      >
                        لغو
                      </button>
                      <button
                        type="submit"
                        className={`${
                          transactionType === "buy"
                            ? "bg-green-500 hover:bg-green-700"
                            : "bg-red-500 hover:bg-red-700"
                        } rounded-full px-4 py-2 mx-2 tracking-wider text-white transition-all duration-100 ${largerStyles.buttonText}`}
                        disabled={isSubmitting}
                      >
                        {isSubmitting
                          ? "در حال ثبت..."
                          : transactionType === "buy"
                            ? "خرید"
                            : "فروش"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            ) : (
              // Result Modal
              <div className="w-full px-7 py-6 bg-[#101632] rounded-lg">
                {" "}
                {/* px-6 به px-7، py-5 به py-6 */}
                {transactionId ? (
                  // Success
                  <div className="flex flex-col items-center space-y-6">
                    {" "}
                    {/* space-y-5 به space-y-6 */}
                    <div className="text-center">
                      <p
                        className={`${
                          transactionType === "buy"
                            ? "text-green-600"
                            : "text-red-600"
                        } font-bold ${largerStyles.modalTitle}`}
                      >
                        به صفحه معاملات جاری رجوع کنید
                      </p>
                      <p className="text-slate-700 mt-3 text-lg">
                        شماره سفارش: #{transactionId}
                      </p>
                    </div>
                    <div className="flex space-x-4">
                      <NavLink to="/Public/Live-Transactions">
                        <button
                          onClick={resetForm}
                          className="bg-yellow-500 hover:bg-green-700 text-slate-700 rounded-full px-5 py-2 transition-colors text-lg"
                        >
                          معاملات جاری
                        </button>
                      </NavLink>
                      <button
                        onClick={resetForm}
                        className="bg-green-500 hover:bg-green-700 text-white rounded-full px-5 py-2 transition-colors text-lg"
                      >
                        بستن
                      </button>
                    </div>
                  </div>
                ) : (
                  // Error
                  <div className="flex flex-col items-center space-y-6">
                    <p
                      className={`text-red-600 font-bold text-center ${largerStyles.modalTitle}`}
                    >
                      خطا در ثبت تراکنش!
                    </p>
                    <p className="text-slate-700 text-center text-lg">
                      {" "}
                      {/* text-base به text-lg */}
                      لطفاً دوباره تلاش کنید.
                    </p>
                    <button
                      onClick={resetForm}
                      className="bg-red-500 hover:bg-red-700 text-white rounded-full px-5 py-2 transition-colors text-lg"
                    >
                      بستن
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ListUi;
